import { CommonModule } from '@angular/common'
import { Component, Input, OnInit } from '@angular/core'

@Component({
    selector: 'app-title',
    templateUrl: './title.component.html',
    styleUrls: ['./title.component.scss'],
    imports: [CommonModule]
})
export class TitleComponent implements OnInit {
  @Input() title = ''
  constructor() {}

  ngOnInit(): void {}
}
